import { setStats } from '../../../client/actions/statsSection';

export function getStatsSectionInitActions(responseData, requestParams) {
  return [setStats(responseData.sectionData)];
}
